import { useEffect } from "react";

/**
 * Докато `open`, Esc вика `close` и НЕ стига по-нататък (capture +
 * preventDefault): затваря само горното ниво — календара, не панела под него
 * и не глобалното „назад". Нужно е за календарите, чийто скрит input не е на
 * фокус, затова antd не хваща Esc сам.
 */
export const useEscapeToClose = (open: boolean, close: () => void) => {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      event.preventDefault();
      event.stopPropagation();
      close();
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [open, close]);
};
